export default {
  showActorList: true,
  showVersionBar: true,
  reportMetric1Color: '#de82ad',
  reportMetric2Color: '#9997c9',
  baseURL: process.env.REACT_APP_WS_END_POINT,
} as any;
